import { LandingPage as LandingPageForm } from '@bgea-js/form-templates';
import customConfirmationDO from "../../../../src/content/decision-offer/customConfirmation";
import * as React from 'react';
export default {
  LandingPageForm,
  customConfirmationDO,
  React
};